import { Collapse, Space } from "antd";
import { FC } from "react";
import { Header } from "./header";
import { VehicleInventory } from "./vehicle-inventory";
import { VesselModal } from "../vessel-modal";
import { ListShuttles } from "../list-shuttles";
import { useVesselStore } from "../store/vessel.store";

type Props = {};

export const ListVessels: FC<Props> = () => {
  const { listState } = useVesselStore();
  return (
    <Space direction="vertical" size="large" style={{ width: "100%" }}>
      <Header />
      {listState === "vessels" ? <VehicleInventory /> : <ListShuttles />}
      <Collapse
        collapsible="header"
        items={[
          {
            key: "expense-tracking",
            label: "Expense Tracking (coming soon)",
            children: null,
          },
        ]}
      />
      <VesselModal />
    </Space>
  );
};
